<template>
  <form class="c-step c-step--three" v-on:submit.prevent>
    <technoLogo />

    <InputText
      :dataText="app.userInfo.fullName"
      :dataTitle="'Fulde navn*'"
      :dataType="'Name'"
      :dataIsRequired="true"
      :dataInputType="'text'"
      :dataInputSize="100"
      v-on:childToParent="nameChange"
    />
    <InputText
      :dataText="app.userInfo.cpr"
      :dataTitle="'CPR-nummer*'"
      :dataType="'CPR'"
      :dataIsRequired="true"
      :dataInputType="'text'"
      :dataInputSize="11"
      :dataInputPattern="'^[0-9]{6}-[0-9]{4}$|^[0-9]{10}$'"
      :dataInputTitle="'Eksempel på CPR nummer: 000000-0000)'"
      v-on:childToParent="cprChange"
    />
    <InputText
      :dataText="app.userInfo.phone"
      :dataTitle="'Telefon*'"
      :dataType="'Telephone'"
      :dataIsRequired="true"
      :dataInputType="'text'"
      :dataInputPattern="'^[0-9]{8}$'"
      :dataInputSize="100"
      :dataInputTitle="'Eksempel på telefonnummer: 99221133'"
      v-on:childToParent="telephoneChange"
    />
    <InputText
      :dataText="app.userInfo.email"
      :dataTitle="'E-mail*'"
      :dataType="'Email'"
      :dataIsRequired="true"
      :dataInputType="'email'"
      :dataInputSize="100"
      :dataInputPattern="'[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$'"
      :dataInputTitle="'Eksempel på E-mail: xxxxxx@yyyy.dk'"
      v-on:childToParent="emailChange"
    />

    <InputText
      :dataText="app.userInfo.licenseplate"
      :dataTitle="'Nummerplade*'"
      :dataType="'Licenseplate'"
      :dataIsRequired="true"
      :dataInputType="'text'"
      :dataInputSize="10"
      v-on:childToParent="licenseplateChange"
      :dataNote="
        'Hvis du ikke kender nummerpladen, så skriv bilens mærke, model, årgang og motor i bemærkningsfeltet'
      "
    />
    <TextArea
      :dataText="app.userInfo.comment"
      :dataTitle="'Bemærkning'"
      :dataType="'Comment'"
      v-on:childToParent="commentChange"
    />

    <Checkbox
      class="samtykke-checkbox"
      :dataChecked="app.userInfo.consent"
      :dataType="'AcceptTerms'"
      :dataText="
        ' Jeg giver mit samtykke til, at WIA I/S kan opbevare og behandle de af mig afgivne oplysninger, og videregive oplysningerne til de relevante forsikringsselskaber med henblik på at indhente forsikringstilbud. *'
      "
      :dataIsRequired="true"
      v-on:childToParent="acceptTermsChange"
    />

    <Paragraph
      :class="[
        'validate-info',
        {
          show:
            app.userInfo.fullName == '' ||
            app.userInfo.phone == '' ||
            app.userInfo.email == '' ||
            app.userInfo.consent != true
        }
      ]"
      :dataParagraph="'Venligst udfyld alle påkrævede felter'"
    />
    <Button
      :buttonId="'order-techno-offer'"
      text="Bestil tilbud"
      :give-padding="true"
      :isActive="true"
      :disabled="
        app.userInfo.fullName == '' ||
          app.userInfo.phone == '' ||
          app.userInfo.email == '' ||
          app.userInfo.consent != true
      "
      v-on:childToParent="buttonClick"
    />

    <!-- <p class="pt-5">Forsikringen er tegnet i Købstædernes Forsikring G/S. Købstædernes Forsikring er omfattet af Garantifonden for skadeforsikringsselskaber. Garantifonden omfatter motoransvar og kaskoforsikring, og i tilfælde af forsikringsselskabets konkurs er kundens krav omfattet af denne garanti.</p> -->
  </form>
</template>
<script>
// @ is an alias to /src
import Vue from 'vue';
import InputText from '@/components/input-text/input-text.vue';
import TextArea from '@/components/textarea/textarea.vue';
import Checkbox from '@/components/checkbox/checkbox.vue';
import Button from '@/components/button/button.vue';
import Paragraph from '@/components/paragraph/paragraph.vue';
import technoLogo from '@/components/technoLogo/technoLogo.vue';

import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('app');

export default Vue.extend({
  name: 'Step3',
  components: {
    InputText,
    TextArea,
    Checkbox,
    Button,
    Paragraph,
    technoLogo
  },
  methods: {
    nameChange(e) {
      this.$store.dispatch('app/nameChange', e);
    },
    cprChange(e) {
      this.$store.dispatch('app/cprChange', e);
    },
    telephoneChange(e) {
      this.$store.dispatch('app/telephoneChange', e);
    },
    emailChange(e) {
      this.$store.dispatch('app/emailChange', e);
    },
    licenseplateChange(e) {
      this.$store.dispatch('app/licenseplateChange', e);
    },
    commentChange(e) {
      this.$store.dispatch('app/commentChange', e);
    },
    acceptTermsChange(e) {
      this.$store.dispatch('app/acceptTermsChange', e);
    },
    buttonClick() {
      if (
        this.app.error == '' &&
        this.app.userInfo.fullName != '' &&
        this.app.userInfo.phone != '' &&
        this.app.userInfo.email != '' &&
        this.app.userInfo.consent == true
      ) {
        this.$store.dispatch('app/makeInsuranceOffer');
        this.$router.push({ name: 'ThankYou' });
      }
    },
    triggerScrollToTop() {
      window.parent.postMessage(
        {
          action: 13,
          namespace: 'bt',
          data: {
            containerId: this.$store.getters['app/app'].containerId,
            offset: -61
          }
        },
        this.$store.getters['app/app'].host
      );
    }
  },
  mounted() {
    this.$store.dispatch('app/loading', false);
    this.triggerScrollToTop();
  },
  computed: {
    ...mapGetters(['app'])
  }
});
</script>
<style lang="scss">
@import '@/assets/scss/components/step.scss';
.c-technoLogo {
  width: 100%;
  .c-technoLogo__logo {
    height: 40px;
    width: 100px;
    margin-left: 1.3rem;
  }
}

.validate-info {
  opacity: 0;
  text-align: center;
  width: 100%;
  font-size: 1rem;
  font-weight: bold;
  color: #424242;
  &.show {
    opacity: 1;
  }
}
.samtykke-checkbox {
  .c-checkbox__visual {
    width: 1rem;
    height: 1rem;
    margin-top: 0.5rem;
  }
}
</style>
